import React, { useState } from 'react'

import "./navbar.css"
import { RiMenu3Line, RiCloseLine, RiArrowDownSLine, RiArrowUpSLine} from 'react-icons/ri';
import { useLocation } from 'react-router-dom';
//Electricity Market Advisory Services

export default function Navbar() {

  const location = useLocation()

  const Menu = () => (
    <>
    <div className='emas__navbar-links_menu'>
        <div className={location.pathname === "/" ? 'emas__navbar-links_menu-on' : 'emas__navbar-links_menu-off'}>
          <div>
          <a href="../">Home</a>
          </div>
        </div>
        <div className={location.pathname === "/Publications" ? 'emas__navbar-links_menu-on' : 'emas__navbar-links_menu-off'}>
          <a href="../Publications">Market Commentary</a>
        </div>
        {/* <div className={'emas__navbar-links_menu-off'}>
          <div className='emas__navbar-links_menu-content'>
            <p>Client Dashboard</p><RiArrowDownSLine size={25}/>
          </div>
        //   <div className={color ? 'emas__navbar-links_menu-open scale-up-top emas__navbar-links_menu-open_scroll' : 'emas__navbar-links_menu-open scale-up-top'}>
        //     <a href="../Contact-Us">Contact Us</a>
        //     <a href="../client-login">Client Login</a>
        //     <a href="../Dashboard">Dashboard</a>
        //   </div>
        // </div> */}
        <div className={location.pathname === "/Solar" ? 'emas__navbar-links_menu-on' : 'emas__navbar-links_menu-off'}>
          <a href="../Solar">Solar Calculator</a>
        </div>
        <div className={location.pathname === "/Dashboard" ? 'emas__navbar-links_menu-on' : 'emas__navbar-links_menu-off'}>
          <a href="../Dashboard">Client Portal</a>
        </div>
        <div className={location.pathname === "/About-Us" ? 'emas__navbar-links_menu-on' : 'emas__navbar-links_menu-off'}>
          <a href="../About-Us">About Us</a>
        </div>
    </div>
    </>
  )

  const Menu2 = () => (
    <>
      <div className='emas__navbar-sidemenu_container-link'>
        <a href="../">Home</a>
      </div>
      {/* <div className='emas__navbar-sidemenu_container-link'>
        <div className='emas__navbar-sidemenu_container-link_row'>
          <p>Services</p>
          {toggleServices
            ?  <RiArrowUpSLine color="white" size={22} onClick={() => setToggleServices(false)}/>
            : <RiArrowDownSLine color='white' size={22} onClick={() => setToggleServices(true) & setToggleSupport(false)} />
          }
        </div>
        {toggleServices && (
          <div className='emas__navbar-sidemenu_container-link_open scale-up-top'>
              <a href="../Electricity-Market-Modeling">Electricity Market Modelling</a>
              <a href="../Other-Modeling">Other Modelling</a>
          </div>
        )}
      </div> */}
      <div className='emas__navbar-sidemenu_container-link'>
        <div className='emas__navbar-sidemenu_container-link_row'>
        <a href="../Publications">Market Commentary</a>
          {/* {toggleSupport
            ?  <RiArrowUpSLine color="white" size={22} onClick={() => setToggleSupport(false)}/>
            : <RiArrowDownSLine color='white' size={22} onClick={() => setToggleSupport(true) & setToggleServices(false)} />
          } */}
        </div>
        {/* {toggleSupport && (
          <div className='emas__navbar-sidemenu_container-link_open scale-up-top'>
            <a href="../Contact-Us">Contact Us</a>
            <a href="../client-login">Client Login</a>
            <a href="../Dashboard">Dashboard</a>
          </div>
        )} */}
      </div>
              <div className='emas__navbar-sidemenu_container-link'>
          <a href="../Solar">Solar Calculator</a>
      </div>
      <div className='emas__navbar-sidemenu_container-link'>
          <a href="../Dashboard">Client Portal</a>
      </div>
      <div className='emas__navbar-sidemenu_container-link'>
        <a href="../About-Us">About Us</a>
      </div>

    </>
  )
  
  const [color, setColor] = useState(location.pathname === "/Publications" || location.pathname === "/Dashboard" || location.pathname === "/Solar" ? true : false);

  const changeColor = () => {
    if (location.pathname === "/About-Us") {
      if (window.innerWidth <= 414) {
        if (window.scrollY >= 600) {
          setColor(true);
        } else {
          setColor(false);
        }
      }
       else if (window.scrollY >= 700) {
        setColor(true);
      } else {
        setColor(false);
      }
    } else if (location.pathname === "/") {
      if (window.innerWidth <= 414) {
        if (window.scrollY >= 400) {
          setColor(true);
        } else {
          setColor(false);
        }
      }
      else if (window.scrollY >= 1100) {
        setColor(true);
      } else {
        setColor(false);
      }
    } else {
      setColor(true);
      return;
    }
  }

  window.addEventListener('scroll', changeColor)

  const [toggleMenu, setToggleMenu] = useState(false);
  const [toggleSupport, setToggleSupport] = useState(false);
  const [toggleServices, setToggleServices] = useState(false);

  return (
    <div className={color ? 'emas__navbar-scroll emas__navbar': "emas__navbar"}>
      <div className='emas__navbar-heading'>
        <h1><a href='../'>E M A S</a></h1>
      </div>
      <div className='emas__navbar-links'>
        <Menu />
      </div>
      <div className={color ? 'emas__navbar-sidemenu_scroll emas__navbar-sidemenu' : "emas__navbar-sidemenu"}>
        {toggleMenu 
                ? <RiCloseLine color='white' size={27} onClick={() => setToggleMenu(false) & setColor(false)  } className="thesvg"/>
                : <RiMenu3Line color='white' size={27} onClick={() => setToggleMenu(true) & setColor(true) }/>
              }
        {toggleMenu && (
          <div className={color ? 'emas__navbar-sidemenu_container-scroll emas__navbar-sidemenu_container scale-up-top' : 'emas__navbar-sidemenu_container scale-up-top'}>
            <Menu2 />
          </div>
        )}
      </div>
    </div>
  )
}
